import { render, staticRenderFns } from "./CIComment.vue?vue&type=template&id=5d30ce74&scoped=true&"
import script from "./CIComment.vue?vue&type=script&lang=js&"
export * from "./CIComment.vue?vue&type=script&lang=js&"
import style0 from "./CIComment.vue?vue&type=style&index=0&id=5d30ce74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d30ce74",
  null
  
)

export default component.exports